"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExplorePoolsPaginatedListSchema = exports.ExplorePoolsSchema = void 0;
const core_contracts_ifaces_1 = require("@tutellus/core-contracts-ifaces");
const zod_1 = require("zod");
const VolumeStats_1 = require("./VolumeStats");
exports.ExplorePoolsSchema = zod_1.z.object({
    poolID: zod_1.z.string(),
    tvl: zod_1.z.array(core_contracts_ifaces_1.CurrencyAmountSchema).optional(),
    apr: zod_1.z.number(),
    volumeRatio: zod_1.z.number(),
    volume: VolumeStats_1.VolumeStatsSchema,
});
exports.ExplorePoolsPaginatedListSchema = zod_1.z.object({
    items: zod_1.z.array(exports.ExplorePoolsSchema),
    metadata: core_contracts_ifaces_1.PaginationMetadataSchema,
});
